<div class="simple-table-container" ms-responsive-table>
    <div
        class="table-title light-blue-600 font-size-16"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <span class="lista-atividades-title">{{ atividadeText }} - Hoje</span>
        <button
            mat-icon-button
            fuseWidgetToggle
            aria-label="more"
            (click)="handleAtividade()"
        >
            <mat-icon class="logo-icon s-24 mr-8">launch</mat-icon>
        </button>
    </div>

    <div
        class="pl-16 pr-8 py-16 light-blue-fg font-size-32"
        fxLayout="column"
        fxLayoutAlign="center center"
        style="height: 100%"
    >
        <div
            class="light-blue-fg font-size-32 line-height-26"
            fxLayout="column"
            fxLayoutAlign="center center"
            [@animate]="{ value: '*', params: { delay: '50ms', scale: '0.2' } }"
        >
            <span
                class="light-blue-fg"
                style="cursor: pointer"
                (click)="handleAtividade()"
            >
                {{ meta && meta.total ? meta.total : "0" }}
            </span>
            <span class="h2">Quantidade de Atividades Hoje</span>
            <span class="h5">Clique no numero para ir para lista</span>
        </div>
    </div>
</div>
